/* eslint-disable spire/export-styles */
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { getIsWebCrawler } from "@insite/client-framework/Common/WebCrawler";
import { ConfigurationType } from "@insite/client-framework/Services/ProductServiceV2";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import ProductAvailability, { ProductAvailabilityStyles } from "@insite/content-library/Components/ProductAvailability";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

interface OwnProps {
    extendedStyles?: ProductAvailabilityStyles;
    product?: any;
    productInfo?: ProductInfo;
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    return {
        includeRealTimeInventoryAndPricingForSeo:
            getSettingsCollection(state).websiteSettings.includeRealTimeInventoryAndPricingForSeo,
    };
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const AHRIRelatedProductContextAvailability = ({
    includeRealTimeInventoryAndPricingForSeo,
    product,
    productInfo,
    extendedStyles,
}: Props) => {
    const [availability, setAvailability] = useState<any>(undefined);
    
    useEffect(() => {

        const val = productInfo?.inventory?.inventoryAvailabilityDtos?.find(
            (o: any) => o.unitOfMeasure.toLowerCase() === (productInfo?.unitOfMeasure?.toLowerCase() || ""),
        )?.availability || undefined;
        setAvailability(val);

    },[productInfo])
    
    if (
        (getIsWebCrawler() && !includeRealTimeInventoryAndPricingForSeo) ||
        product.isVariantParent ||
        (!!product.configurationType &&
            product.configurationType !== ConfigurationType.None &&
            product.configurationType !== ConfigurationType.Fixed)
    ) {
        return null;
    }

    return (
        <ProductAvailability
            productId={product.id}
            trackInventory={product.trackInventory}
            availability={availability}
            unitOfMeasure={productInfo?.unitOfMeasure ?? ""}
            isProductDetailsPage={false}
            failedToLoadInventory={false}
            extendedStyles={extendedStyles}
        />
    );
};

export default connect(mapStateToProps)(AHRIRelatedProductContextAvailability);
